import React from 'react';
import {TabBar, Tab, TabIcon, TabIconText} from 'rmwc/Tabs';
import {Button} from 'rmwc/Button';
import {TextField} from 'rmwc/TextField';
import {List, ListItem, ListItemText, ListItemSecondaryText, ListItemGraphic, ListItemMeta, SimpleListItem} from 'rmwc/List'
import {Snackbar} from 'rmwc/Snackbar';
import '@material/tabs/dist/mdc.tabs.min.css';
import '@material/button/dist/mdc.button.min.css';
import '@material/textfield/dist/mdc.textfield.min.css';
import '@material/list/dist/mdc.list.min.css';
import logo from './logo.svg';
import './Publisher.css';

const TabRSS = () => {
  return (
    <div>
      <Button unelevated>复制</Button>
    </div>
  )
}

const TabEmail = ({subscribeHandle}) => {
  return (
    <div>
      <TextField outlined label="订阅到邮箱" />
      <Button unelevated onClick={subscribeHandle}>订阅</Button>
    </div>
  )
}

const TabAPI = () => {
  return (
    <div>
      <Button unelevated>测试</Button>
    </div>
  )
}

export default class Publisher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
    }
  }

  render() {
    const Cover = <img src="https://cdn.sspai.com/article/8a28d2af-bf78-55fe-3a03-dcdbf811c141.jpg?imageMogr2/quality/95/thumbnail/!700x233r/gravity/Center/crop/700x233" />
    return (
      <div>
        <p>小道消息</p>
        <TabBar actiiveTabIndex={this.state.activeTabIndex} 
          onChange={evt => this.setState({'activeTabIndex': evt.target.value})}>
          <Tab>RSS订阅</Tab>
          <Tab>邮件订阅</Tab>
          <Tab>API</Tab>
        </TabBar>
        <div>
          {this.state.activeTabIndex == 0 && <TabRSS />}
          {this.state.activeTabIndex == 1 && <TabEmail />}
          {this.state.activeTabIndex == 2 && <TabAPI />}
        </div>
        <List twoLine>
          <ListItem>
            <ListItemGraphic>sdfasdf</ListItemGraphic>
            <ListItemText>分享你的 Smartisan 使用技巧，免费拿下一款锤子手机
              <ListItemSecondaryText>说到锤子手机的亮点功能，首先想到的通常就是 Smartisan OS，它不但是很多人购买锤子手机的主要原因</ListItemSecondaryText>
            </ListItemText>
          </ListItem>
        </List>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Publisher.js